import { call, put, takeLatest } from "redux-saga/effects";

import { getAdminConfigurations } from "@utils/api-communication/RestApiCli";
import { normalizeAdminConfigurations } from "@utils/adminConfigurationUtils";
import { AdminConfigurationsResponse } from "types/adminConfigurationTypes";
import { fetchAdminConfigurations, setAdminConfigurations } from "./adminConfigurationsSlice";

function* loadAdminConfigurations() {
  try {
    const response: AdminConfigurationsResponse = yield call(getAdminConfigurations);
    yield put(setAdminConfigurations(normalizeAdminConfigurations(response)));
  } catch (error) {
    console.error("Failed to load admin configurations", error);
  }
}

export default function* adminConfigurationsSagas() {
  yield takeLatest(fetchAdminConfigurations.type, loadAdminConfigurations);
}
